import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-armsport-competition',
  templateUrl: './armsport-competition.component.html',
  styleUrls: ['./armsport-competition.component.scss']
})
export class ArmsportCompetitionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
